$(document).ready(function() {
  if ($(".select2, .multiselect2, .select2-basic").length > 0) {
    $(".select2, .select2-basic").select2({
      width: 'resolve'
    });
  }

  if ($(".select2-remote").length > 0) {
    $(".select2-remote").select2({
      ajax: {
        url: function() {
          return this.data().url;
        },
        datatype: 'json',
        delay: 250,
        minimumInputLength: 3,
        data: function (params) {
          var query = {
            search: params.term,
            page: params.page || 1
          }

          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data) {
          data.unshift({id: "", text: "Clear"})

          return {
           results: data
          };
        }
      },
      escapeMarkup: function(m) {
        return m;
      }
    });
  }

  if ($(".datepicker").length > 0) {
    $(".datepicker").datepicker({
      changeMonth: true,
      changeYear: true
    });
  }

  if ($(".month-day-picker").length > 0) {
    $(".month-day-picker").datepicker({
      changeMonth: true,
      changeYear: true,
      dateFormat: 'mm/dd'
    });
  }
});
